import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import {
  toWidget,
  toWidgetEditable,
} from "@ckeditor/ckeditor5-widget/src/utils"
import { enablePlaceholder } from "@ckeditor/ckeditor5-engine/src/view/placeholder"
import Widget from "@ckeditor/ckeditor5-widget/src/widget"
import InsertArticleLinkBox from "./insertArticleLinkBox"

export default class ArticleLinkBoxEditing extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this.defineSchema()
    this.defineConvrters()
    this.editor.commands.add(
      "insertArticleLinkBox",
      new InsertArticleLinkBox(this.editor)
    )
  }

  defineSchema() {
    const schema = this.editor.model.schema

    schema.register("articleLinkBox", {
      isObject: true,
      allowWhere: "$block",
    })
    schema.register("articleLinkBoxLabel", {
      allowIn: "articleLinkBox",
      allowContentOf: "$block",
    })
    schema.register("articleLinkBoxId", {
      isLimit: true,
      allowIn: "articleLinkBox",
      allowContentOf: "$block",
    })
    schema.register("articleLinkBoxExcuse", {
      allowIn: "articleLinkBox",
      allowContentOf: "$block",
    })
  }

  defineConvrters() {
    const conversion = this.editor.conversion
    conversion.for("upcast").elementToElement({
      model: "articleLinkBox",
      view: {
        name: "div",
        classes: "article-link-box",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "articleLinkBox",
      view: {
        name: "div",
        classes: "article-link-box",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "articleLinkBox",
      view: (modelElement, viewWriter) => {
        const section = viewWriter.createContainerElement("div", {
          class: "article-link-box",
        })

        return toWidget(section, viewWriter, {
          label: "article link box widget",
        })
      },
    })

    // <articleLinkBoxLabel> converters
    conversion.elementToElement({
      model: "articleLinkBoxLabel",
      view: {
        name: "label",
        classes: "article-link-box-label",
      },
    })

    // <articleLinkBoxExcuse> converters
    conversion.elementToElement({
      model: "articleLinkBoxExcuse",
      view: {
        name: "p",
        classes: "article-link-box-excuse",
      },
    })

    // <articleLinkBoxId> converters
    conversion.for("upcast").elementToElement({
      model: "articleLinkBoxId",
      view: {
        name: "h3",
        classes: "article-link-box-id",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "articleLinkBoxId",
      view: {
        name: "h3",
        classes: "article-link-box-id",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "articleLinkBoxId",
      view: (modelElement, viewWriter) => {
        const view = viewWriter.createEditableElement("h3", {
          class: "article-link-box-id",
        })
        enablePlaceholder({
          view: this.editor.editing.view,
          element: view,
          text: "記事ID 例:9999",
        })
        return toWidgetEditable(view, viewWriter)
      },
    })
  }
}
